<div class="basic-update-component-container">
  <p>Basic data update</p>

  <div id="basic-update-canvas"></div>
</div>
